export enum DailyChallengeAnimation {
  build = 'build',
  loop = 'loop',
  celebrate = 'celebrate',
}
